
import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { Redirect } from "react-router-dom";
import Button from 'react-bootstrap/Button'
import Card from "react-bootstrap/esm/Card";
import ReactHtmlParser from 'react-html-parser';
import api from '../../services/api';
import Accordion from 'react-bootstrap/Accordion'

export default function Listafaq() {
  // pág atual e numero de pags
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [nrofpages, setNumberofpage] = useState(1);

  // chama api de acordo com numero de pags
  useEffect(() => {
    api.get("/faq", {
      params: { page: page }
    }).then(response => {
      // total de pags
      setNumberofpage(response.headers["x-wp-totalpages"]);
      setPosts(response.data);
    }).catch(error => {
      return <Redirect to='/not_found/'/>
    });
  }, [page, setPosts]);

  // pag anterior
  const handlePrevPage = () => setPage(page - 1 ? page - 1 : 1);
  // pag posterior
  const handleNextPage = () => setPage(page < nrofpages ? page + 1 : nrofpages);

  return (
    <div className="py-0">
      <Row >
          {posts &&
            posts.length &&
            posts.map((post, index) => {
               return (
                  <Col sm={12} key={post.id}>
                     <Accordion> 
                        <Card  className="mb-3">
                           <Card.Header>
                              <Accordion.Toggle as={Button} variant="link" eventKey={post.id}>
                                 {post.title.rendered}
                              </Accordion.Toggle>
                           </Card.Header>
                           <Accordion.Collapse eventKey={post.id}>
                              <Card.Body>
                                 { ReactHtmlParser(post.content.rendered) }
                              </Card.Body>
                           </Accordion.Collapse>
                        </Card>
                     </Accordion>
                  </Col>
               );         
            })}
      </Row>     
    </div>
  );
}